/* eslint-disable */
import React from 'react';
import AuthStackNavigation from '../routes/authStackNavigator';

import AuthProvider, {
  AuthIsSignedIn,
  AuthIsNotSignedIn,
} from '../contexts/authContext';
import { IAuthAWS } from '../interfaces/IAuthAWS';
import { IAuthFunctionalities } from '../interfaces/IAuthFunctionalities';
import { SmartLaunchAuthRoutes } from 'src/routes';

interface IProps {
  awsConfig: IAuthAWS;
  theme?: undefined;
  authConfig?: IAuthFunctionalities;
}

const AuthModule: React.FC<IProps> = ({
  awsConfig,
  theme,
  authConfig,
  children,
}) => {
  return (
    <AuthProvider config={awsConfig} authConfig={authConfig}>
      {window.location.pathname.includes('smart-launch') ? (
        <SmartLaunchAuthRoutes />
      ) : (
        <>
          <AuthIsSignedIn>{children}</AuthIsSignedIn>
          <AuthIsNotSignedIn>
            <AuthStackNavigation />
          </AuthIsNotSignedIn>
        </>
      )}
    </AuthProvider>
  );
};

export default AuthModule;
